import { getRewardCenterTiersConfigQueryClient } from "@workspace/casino_core/queries/RewardCenterTiersConfigQuery.client";
import type { CmsLocaleInputType } from "@workspace/casino_core/schema";
import { CMS_BRAND_SLUG } from "../../constants";
import type { TierConfiguration } from "../../types";
import mapTierConfiguration from "./mapTierConfiguration";
import { IS_MOCK } from "./mock";

const MOCK: TierConfiguration = {
  tiers: {
    iron: {
      sheen: "#8E99A6",
      body: "#434C57",
      base: "#0F1216",
      bar: "#A9B4C0",
      badgeLight: "#96A2AF",
      badgeDark: "#20262D",
      id: "LoyaltyPublicTier:26",
    },
    bronze: {
      sheen: "#CE9A65",
      body: "#7C5233",
      base: "#171009",
      bar: "#DDB489",
      badgeLight: "#E8B072",
      badgeDark: "#4A2408",
      id: "LoyaltyPublicTier:14",
      rewards: ["ABC"],
    },
    silver: {
      sheen: "#C9DCF0",
      body: "#56687C",
      base: "#0F141A",
      bar: "#DCE9F7",
      badgeLight: "#C3D2E0",
      badgeDark: "#28323D",
      id: "LoyaltyPublicTier:10",
      rewards: ["ABC"],
    },
    gold: {
      sheen: "#E5C169",
      body: "#8A6B23",
      base: "#1B150D",
      bar: "#F0DCA6",
      badgeLight: "#E0B968",
      badgeDark: "#6B4715",
      id: "LoyaltyPublicTier:11",
      rewards: ["ABC"],
    },
    emerald: {
      sheen: "#5FD6A1",
      body: "#0F6B4A",
      base: "#0A1A14",
      bar: "#9CF0C8",
      badgeLight: "#57D79B",
      badgeDark: "#0C3F2C",
      id: "LoyaltyPublicTier:12",
    },
    legend: {
      sheen: "#A886FF",
      body: "#4A24B8",
      base: "#100626",
      bar: "#C4AEFF",
      badgeLight: "#B9A0F5",
      badgeDark: "#22115E",
      id: "LoyaltyPublicTier:13",
    },
    diamond: {
      sheen: "#A9D4FF",
      body: "#3E6E9E",
      base: "#0A141F",
      bar: "#CDE6FF",
      badgeLight: "#9CCDFA",
      badgeDark: "#1B3B58",
      id: "LoyaltyPublicTier:20",
    },
  },
  links: {
    sports: "https://www.google.com",
    casino: "https://www.google.com",
  },
  enabledTabs: { history: true, faq: true },
};

const fetchMyTierConfiguration = async (
  locale?: CmsLocaleInputType,
): Promise<TierConfiguration | undefined> => {
  try {
    if (IS_MOCK) {
      if (Math.floor(Math.random() * 10) === 7) {
        throw new Error("Simulate failing");
      }
      return MOCK;
    }
    const { data } = await getRewardCenterTiersConfigQueryClient({
      locale,
      where: { brandSlug: { equals: CMS_BRAND_SLUG } },
    });
    return mapTierConfiguration(data);
  } catch (error) {
    console.warn("[actors] fetching my tier configuration failed", error);
    return undefined;
  }
};

export default fetchMyTierConfiguration;
